import { Component, Inject, OnInit } from '@angular/core';
import { AlertComponent } from 'src/app/alert/alert.component';
import { PhotoUploadComponent } from '../photo-upload/photo-upload.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OutingApiService } from '../outing-api.service';

@Component({
  selector: 'app-add-family-details-dialog',
  templateUrl: './add-family-details-dialog.component.html',
  styleUrls: ['./add-family-details-dialog.component.scss']
})
export class AddFamilyDetailsDialogComponent implements OnInit {
  selectedRelation: any = ""
  relations: any[] = []
  familyRelations: any;
  relationName: any = "";
  mobilenumber: any = "";
  showerror: any = false;
  relationaadhar: any = "";
  aadharerror: boolean = false;
  relation: any;
  photo: any;
  submitOrNot: any = false;
  relationDetails: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private spinner:NgxSpinnerService, private dialogRef: MatDialogRef<AddFamilyDetailsDialogComponent>, private dialog: MatDialog, private outingservice: OutingApiService) { }
  ngOnInit(): void {
    this.getFamilyRelations()
    if (this.data) {
      this.relationName = this.data?.name ?? "";
      this.mobilenumber = this.data?.mobilenumber ?? "";
      this.selectedRelation = this.data?.selectedRelation.relation ?? "";
      this.relationaadhar = this.data?.aadhar ?? "";
      this.photo = this.data?.croppedImage ?? "";
      this.submitOrNot = true;
    }
  }

  close() {
    this.dialogRef.close()
  }


  getFamilyRelations() {
    this.spinner.show()
    this.outingservice.getFamilyRelations().subscribe({
      next: (res: any) => {
        if (!res) {
          this.familyRelations = []
          this.spinner.hide()
          return;
        }
        else {
          this.spinner.hide()
          this.familyRelations = res
        }
      }
    })
  }

  getRelationName(event: any) {
    this.relationName = event;
  }

  getRelationMobileNumber(event: any) {
    const value = event
    if (value && value.length == 10) {
      this.mobilenumber = value;
      this.showerror = false
    }
    else if (!value || value.length == 0) {
      this.showerror = false
    }
    else {
      this.showerror = true;
    }
  }

  getRelationaadhar(value: any) {
    if (value && value.length == 12) {
      this.relationaadhar = value;
      this.aadharerror = false
    }
    else if (!value || value.length == 0) {
      this.aadharerror = false
    }
    else {
      this.aadharerror = true;
    }
  }

  uploadPhoto() {
    if (this.relationName && this.mobilenumber && this.mobilenumber.length == 10 && this.selectedRelation) {
      this.close()
      const data = {
        name: this.relationName,
        mobilenumber: this.mobilenumber,
        selectedRelation: this.relationDetails,
        aadhar: this.relationaadhar
      }
      this.dialog.open(PhotoUploadComponent, {
        width: '600px',
        height: '600px',
        maxHeight: '70vh',
        data: data
      });
    }
    else {
      this.dialog.open(AlertComponent, {
        width: '400px',
        height: '60px',
        position: { top: '10px', right: '10px' },
        data: {
          message: "please completely fill the details",
          status: false

        }
      })
    }
  }

  Relation(item: any) {
    this.selectedRelation = item;
    this.relationDetails = this.familyRelations.find((r: any) => r.relation == item);
  }

  restrictToNumbers(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  async blobUrlToFile(blobUrl: string, filename: string): Promise<File> {
  const response = await fetch(blobUrl);   // fetch blob data
  const blob = await response.blob();      // get Blob from response
  return new File([blob], filename, { type: blob.type });
}


  submitFamilyDetails() {
    this.spinner.show()
    const uniqueRefId = localStorage.getItem("uniqueRefId")
    const payload = {
      "studentId": uniqueRefId,
      "memberName": this.relationName,
      "memberRelationId": this.data.selectedRelation.relationId,
      "gender": "",
      "contactNumber": this.mobilenumber,
      "emailAddress": "",
      "aadharNumber": this.relationaadhar
    }
    this.outingservice.saveStudentFamilygDetails(payload).subscribe({
      next:async (res: any) => {
        const uniqueRefId = localStorage.getItem("uniqueRefId")
        this.outingservice.uploadFamilyImage(this.data.croppedFile, res.familyId, this.data.selectedRelation.relation, uniqueRefId).subscribe({
          next: (res: any) => {
            this.dialogRef.close();
            this.spinner.hide()
          },
          error: (err: any) => {
            this.spinner.hide()
          }
        })
      },
      error: (err: any) => {
        this.spinner.hide()
      }
    })
  }
}
